var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndiScale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 832,
    height: 137,
    viewBox: "0 0 832 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 120.5,
    x2: 832,
    y2: 120.5,
    stroke: "#D9D9DA",
    strokeDasharray: "2 2"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: 112.5,
    x2: 832,
    y2: 112.5,
    stroke: "#D9D9DA",
    strokeDasharray: "2 2"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: 88.5,
    x2: 832,
    y2: 88.5,
    stroke: "#D9D9DA",
    strokeDasharray: "2 2"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: 80.5,
    x2: 832,
    y2: 80.5,
    stroke: "#D9D9DA",
    strokeDasharray: "2 2"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: 56.5,
    x2: 832,
    y2: 56.5,
    stroke: "#D9D9DA",
    strokeDasharray: "2 2"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: 48.5,
    x2: 832,
    y2: 48.5,
    stroke: "#D9D9DA",
    strokeDasharray: "2 2"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    y1: 24.5,
    x2: 832,
    y2: 24.5,
    stroke: "#D9D9DA",
    strokeDasharray: "2 2"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    y1: 16.5,
    x2: 832,
    y2: 16.5,
    stroke: "#D9D9DA",
    strokeDasharray: "2 2"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    y1: 136.5,
    x2: 832,
    y2: 136.5,
    stroke: "#D9D9DA",
    strokeDasharray: "2 2"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    y1: 128.5,
    x2: 832,
    y2: 128.5,
    stroke: "#D9D9DA",
    strokeDasharray: "2 2"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    y1: 104.5,
    x2: 832,
    y2: 104.5,
    stroke: "#D9D9DA",
    strokeDasharray: "2 2"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    y1: 96.5,
    x2: 832,
    y2: 96.5,
    stroke: "#D9D9DA",
    strokeDasharray: "2 2"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    y1: 72.5,
    x2: 832,
    y2: 72.5,
    stroke: "#D9D9DA",
    strokeDasharray: "2 2"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    y1: 64.5,
    x2: 832,
    y2: 64.5,
    stroke: "#D9D9DA",
    strokeDasharray: "2 2"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    y1: 40.5,
    x2: 832,
    y2: 40.5,
    stroke: "#D9D9DA",
    strokeDasharray: "2 2"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    y1: 32.5,
    x2: 832,
    y2: 32.5,
    stroke: "#D9D9DA",
    strokeDasharray: "2 2"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    y1: 8.5,
    x2: 832,
    y2: 8.5,
    stroke: "#D9D9DA",
    strokeDasharray: "2 2"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    y1: 0.5,
    x2: 832,
    y2: 0.5,
    stroke: "#D9D9DA",
    strokeDasharray: "2 2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.3806 117.58C46.6406 117.58 43.6006 114.54 43.6006 110.8C43.6006 107.06 46.6406 104 50.3806 104C54.1206 104 57.1606 107.04 57.1606 110.78C57.1606 114.52 54.1206 117.58 50.3806 117.58ZM50.3806 107.88C48.7806 107.88 47.4806 109.18 47.4806 110.78C47.4806 112.38 48.7806 113.68 50.3806 113.68C51.9806 113.68 53.2806 112.38 53.2806 110.78C53.2806 109.18 51.9806 107.88 50.3806 107.88Z",
    fill: "#3098F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 136L51.18 126.18C50.64 127.42 49.94 128.58 49.08 129.64C47 132.16 44.1 133.96 40.88 134.7L40 130.92C42.34 130.38 44.46 129.06 45.98 127.22C47.54 125.32 48.38 123 48.38 120.54L52.1 119.62L60.0001 134.16L56.5 136Z",
    fill: "#3098F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.976 112.975C92.301 112.975 88.501 109.175 88.501 104.5C88.501 99.825 92.301 96 96.976 96C101.651 96 105.451 99.8 105.451 104.475C105.451 109.15 101.651 112.975 96.976 112.975ZM96.976 100.85C94.976 100.85 93.351 102.475 93.351 104.475C93.351 106.475 94.976 108.1 96.976 108.1C98.976 108.1 100.601 106.475 100.601 104.475C100.601 102.475 98.976 100.85 96.976 100.85Z",
    fill: "#3098F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104.625 136L97.975 123.725C97.3 125.275 96.425 126.725 95.35 128.05C92.75 131.2 89.125 133.45 85.1 134.375L84 129.65C86.925 128.975 89.575 127.325 91.475 125.025C93.425 122.65 94.475 119.75 94.475 116.675L99.125 115.525L109 133.7L104.625 136Z",
    fill: "#3098F3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M148.571 108.37C142.961 108.37 138.401 103.81 138.401 98.2C138.401 92.59 142.961 88 148.571 88C154.181 88 158.741 92.56 158.741 98.17C158.741 103.78 154.181 108.37 148.571 108.37ZM148.571 93.82C146.171 93.82 144.221 95.77 144.221 98.17C144.221 100.57 146.171 102.52 148.571 102.52C150.971 102.52 152.921 100.57 152.921 98.17C152.921 95.77 150.971 93.82 148.571 93.82Z",
    fill: "#3098F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M157.75 136L149.77 121.27C148.96 123.13 147.91 124.87 146.62 126.46C143.5 130.24 139.15 132.94 134.32 134.05L133 128.38C136.51 127.57 139.69 125.59 141.97 122.83C144.31 119.98 145.57 116.5 145.57 112.81L151.15 111.43L163 133.24L157.75 136Z",
    fill: "#3098F3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M205.167 103.765C198.622 103.765 193.302 98.4451 193.302 91.9C193.302 85.355 198.622 80 205.167 80C211.712 80 217.032 85.32 217.032 91.865C217.032 98.4101 211.712 103.765 205.167 103.765ZM205.167 86.79C202.367 86.79 200.092 89.065 200.092 91.865C200.092 94.665 202.367 96.9401 205.167 96.9401C207.967 96.9401 210.242 94.665 210.242 91.865C210.242 89.065 207.967 86.79 205.167 86.79Z",
    fill: "#3098F3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M215.875 136L206.565 118.815C205.62 120.985 204.395 123.015 202.89 124.87C199.25 129.28 194.175 132.43 188.54 133.725L187 127.11C191.095 126.165 194.805 123.855 197.465 120.635C200.195 117.31 201.665 113.25 201.665 108.945L208.175 107.335L222 132.78L215.875 136Z",
    fill: "#3098F3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M266.762 99.1601C259.282 99.1601 253.202 93.0801 253.202 85.6C253.202 78.12 259.282 72 266.762 72C274.242 72 280.322 78.08 280.322 85.56C280.322 93.0401 274.242 99.1601 266.762 99.1601ZM266.762 79.76C263.562 79.76 260.962 82.36 260.962 85.56C260.962 88.7601 263.562 91.3601 266.762 91.3601C269.962 91.3601 272.562 88.7601 272.562 85.56C272.562 82.36 269.962 79.76 266.762 79.76Z",
    fill: "#3098F3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M279 136L268.36 116.36C267.28 118.84 265.88 121.16 264.16 123.28C260 128.32 254.2 131.92 247.76 133.4L246 125.84C250.68 124.76 254.92 122.12 257.96 118.44C261.08 114.64 262.76 110 262.76 105.08L270.2 103.24L286 132.32L279 136Z",
    fill: "#3098F3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M333.358 94.5551C324.943 94.5551 318.103 87.7151 318.103 79.3001C318.103 70.885 324.943 64 333.358 64C341.773 64 348.613 70.84 348.613 79.2551C348.613 87.6701 341.773 94.5551 333.358 94.5551ZM333.358 72.73C329.758 72.73 326.833 75.655 326.833 79.2551C326.833 82.8551 329.758 85.7801 333.358 85.7801C336.958 85.7801 339.883 82.8551 339.883 79.2551C339.883 75.655 336.958 72.73 333.358 72.73Z",
    fill: "#3098F3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M347.125 136L335.155 113.905C333.94 116.695 332.365 119.305 330.43 121.69C325.75 127.36 319.225 131.41 311.98 133.075L310 124.57C315.265 123.355 320.035 120.385 323.455 116.245C326.965 111.97 328.855 106.75 328.855 101.215L337.225 99.145L355 131.86L347.125 136Z",
    fill: "#3098F3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M404.953 89.9501C395.603 89.9501 388.003 82.3501 388.003 73C388.003 63.65 395.603 56 404.953 56C414.303 56 421.903 63.6 421.903 72.95C421.903 82.3001 414.303 89.9501 404.953 89.9501ZM404.953 65.7C400.953 65.7 397.703 68.95 397.703 72.95C397.703 76.95 400.953 80.2 404.953 80.2C408.953 80.2 412.203 76.95 412.203 72.95C412.203 68.95 408.953 65.7 404.953 65.7Z",
    fill: "#3098F3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M420.25 136L406.95 111.45C405.6 114.55 403.85 117.45 401.7 120.1C396.5 126.4 389.25 130.9 381.2 132.75L379 123.3C384.85 121.95 390.15 118.65 393.95 114.05C397.85 109.3 399.95 103.5 399.95 97.3501L409.25 95.05L429 131.4L420.25 136Z",
    fill: "#3098F3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M481.548 85.3451C471.263 85.3451 462.903 76.9851 462.903 66.7C462.903 56.415 471.263 48 481.548 48C491.833 48 500.193 56.36 500.193 66.645C500.193 76.9301 491.833 85.3451 481.548 85.3451ZM481.548 58.67C477.148 58.67 473.573 62.245 473.573 66.645C473.573 71.045 477.148 74.6201 481.548 74.6201C485.948 74.6201 489.523 71.045 489.523 66.645C489.523 62.245 485.948 58.67 481.548 58.67Z",
    fill: "#3098F3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M498.375 136L483.745 108.995C482.26 112.405 480.335 115.595 477.97 118.51C472.25 125.44 464.275 130.39 455.42 132.425L453 122.03C459.435 120.545 465.265 116.915 469.445 111.855C473.735 106.63 476.045 100.25 476.045 93.4848L486.275 90.9548L508 130.94L498.375 136Z",
    fill: "#3098F3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M563.144 80.7401C551.924 80.7401 542.804 71.6201 542.804 60.4C542.804 49.18 551.924 40 563.144 40C574.364 40 583.484 49.12 583.484 60.34C583.484 71.5601 574.364 80.7401 563.144 80.7401ZM563.144 51.64C558.344 51.64 554.444 55.54 554.444 60.34C554.444 65.14 558.344 69.0401 563.144 69.0401C567.944 69.0401 571.844 65.14 571.844 60.34C571.844 55.54 567.944 51.64 563.144 51.64Z",
    fill: "#3098F3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M581.5 136L565.54 106.54C563.92 110.26 561.82 113.74 559.24 116.92C553 124.48 544.3 129.88 534.64 132.1L532 120.76C539.02 119.14 545.38 115.18 549.94 109.66C554.62 103.96 557.14 96.9999 557.14 89.6199L568.3 86.8599L592 130.48L581.5 136Z",
    fill: "#3098F3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M649.739 76.1351C637.584 76.1351 627.704 66.2551 627.704 54.1C627.704 41.945 637.584 32 649.739 32C661.894 32 671.774 41.88 671.774 54.035C671.774 66.1901 661.894 76.1351 649.739 76.1351ZM649.739 44.61C644.539 44.61 640.314 48.835 640.314 54.035C640.314 59.2351 644.539 63.4601 649.739 63.4601C654.939 63.4601 659.164 59.2351 659.164 54.035C659.164 48.835 654.939 44.61 649.739 44.61Z",
    fill: "#3098F3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M669.625 136L652.335 104.085C650.58 108.115 648.305 111.885 645.51 115.33C638.75 123.52 629.325 129.37 618.86 131.775L616 119.49C623.605 117.735 630.495 113.445 635.435 107.465C640.505 101.29 643.235 93.7499 643.235 85.7549L655.325 82.7649L681 130.02L669.625 136Z",
    fill: "#3098F3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M741.335 71.5301C728.245 71.5301 717.604 60.8901 717.604 47.8001C717.604 34.71 728.245 24 741.335 24C754.425 24 765.065 34.64 765.065 47.73C765.065 60.8201 754.425 71.5301 741.335 71.5301ZM741.335 37.58C735.735 37.58 731.185 42.13 731.185 47.73C731.185 53.3301 735.735 57.8801 741.335 57.8801C746.935 57.8801 751.485 53.3301 751.485 47.73C751.485 42.13 746.935 37.58 741.335 37.58Z",
    fill: "#3098F3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M762.75 136L744.13 101.63C742.24 105.97 739.79 110.03 736.78 113.74C729.5 122.56 719.35 128.86 708.08 131.45L705 118.22C713.19 116.33 720.61 111.71 725.93 105.27C731.39 98.6199 734.33 90.4999 734.33 81.8899L747.35 78.6699L775 129.56L762.75 136Z",
    fill: "#3098F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndiScale);
export default __webpack_public_path__ + "static/media/indi-scale.4863348b7b2abafc31b04e94e11b5ae5.svg";
export { ForwardRef as ReactComponent };